export function columnIndexFunc() {
  $('.p-column-article__entry h2').each(function(i) {
    $(this).attr('id', i);
    $('.p-column-article__index-list').append('<li><a href="#'+i+'">'+$(this).text()+'</a></li>');
  });

  $('a[href^="#"]').click(function(){
    var adjust = -100;
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
}
